(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const initializeContactSpamProtection = (root = document) => {
    root
      .querySelectorAll('[data-contact-spam-protection="true"] .contact-form__form')
      .forEach((form) => {
        if (form.dataset.spamProtectionReady === 'true') return;

        form.dataset.spamProtectionReady = 'true';

        const markInteraction = () => {
          if (!form.dataset.interactionStartedAt) {
            form.dataset.interactionStartedAt = String(performance.now());
          }
        };

        form.addEventListener('focusin', markInteraction, { once: true });
        form.addEventListener('input', markInteraction, { once: true });

        form.addEventListener('submit', (event) => {
          const verificationField = form.querySelector('[data-contact-verification-field]');

          if (verificationField && verificationField.value.trim() !== '') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          if (form.dataset.minimumTimePassed === 'true') return;

          const startedAt = Number(form.dataset.interactionStartedAt || performance.now());
          const remainingTime = 1200 - (performance.now() - startedAt);

          if (remainingTime <= 0) return;

          event.preventDefault();
          const submitter = event.submitter;

          window.setTimeout(() => {
            form.dataset.minimumTimePassed = 'true';
            form.requestSubmit(submitter || undefined);
          }, remainingTime);
        });
      });
  };

  initializeContactSpamProtection();

  document.addEventListener('shopify:section:load', (event) => {
    initializeContactSpamProtection(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
